// MHO: from usehooks-ts
import { useEffect, useLayoutEffect } from 'react';

import { isDefined } from '@e-socna/utils';

export const useIsomorphicLayoutEffect = isDefined(window)
  ? useLayoutEffect
  : useEffect;
